<div class="pt-4 flex flex-col gap-4">

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.hotspot-introduction' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-text-editor
        [nl]="introductionForm.controls.nl"
        [en]="introductionForm.controls.en"
        [de]="introductionForm.controls.de"
        [it]="introductionForm.controls.it"
        [fr]="introductionForm.controls.fr"
      />
    </mat-card-content>
  </mat-card>

  @for (hotspot of hotspots(); track $index; let hotspotIndex = $index) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'waters.information.hotspot' | translate }} {{ hotspotIndex + 1 }}</mat-card-title>
        <div class="flex-1"></div>
        <button
          mat-icon-button
          type="button"
          color="warn"
          [aria-label]="'generic.remove' | translate"
          [matTooltip]="'generic.remove' | translate"
          (click)="removeHotspot(hotspotIndex)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content class="!pt-4 flex flex-col gap-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <mat-form-field>
            <mat-label>{{ 'waters.information.hotspot.city' | translate }}</mat-label>
            <input
              matInput
              [value]="hotspot.city ?? ''"
              (change)="setField(hotspotIndex, 'city', $any($event.target).value || null)"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'waters.information.hotspot.distance' | translate }}</mat-label>
            <input
              matInput
              type="number"
              [value]="hotspot.distanceToWater ?? ''"
              (change)="setField(hotspotIndex, 'distanceToWater', +$any($event.target).value || null)"
            />
          </mat-form-field>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
          @for (lang of langs; track lang) {
            <mat-form-field>
              <mat-label>{{ lang.toUpperCase() }}</mat-label>
              <input
                matInput
                [value]="$any(hotspot)['text' + lang.charAt(0).toUpperCase() + lang.slice(1)] ?? ''"
                (change)="setText(hotspotIndex, lang, $any($event.target).value)"
              />
            </mat-form-field>
          }
        </div>
        <p class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'waters.information.hotspot.image' | translate }}</p>
        <app-image-field
          [currentImageName]="getPendingImageName(hotspot) ?? hotspot.imageName"
          [currentImageUrl]="getPendingImageUrl(hotspot) ?? hotspot.imageUrl ?? null"
          (fileSelected)="selectImage(hotspotIndex, $event)"
          (cleared)="clearImage(hotspotIndex)"
        />
      </mat-card-content>
    </mat-card>
  }
  <button mat-stroked-button type="button" class="self-start" (click)="addHotspot()">
    <mat-icon>add</mat-icon>
    {{ 'waters.information.add-hotspot' | translate }}
  </button>

</div>
